export const isKioskCommunicationCategory = (category?: string | null) =>
    category === 'KIOSK' || category === '키오스크 메모';

export const getCommunicationCategoryLabel = (category?: string | null) => {
    if (isKioskCommunicationCategory(category)) {
        return '키오스크';
    }

    switch (category) {
        case 'PTFEEDBACK':
            return 'PT 피드백';
        case 'FACILITY':
            return '시설문의';
        case 'COUNSEL':
            return '상담문의';
        default:
            return '기타';
    }
};

export const isIncomingCommunicationRole = (role?: string | null) =>
    role === 'member' || role === 'kiosk';

export type KioskContentType = 'visitor_memo' | 'manager_call' | 'trainer_promo_lead' | 'other';

export interface ParsedKioskContent {
    type: KioskContentType;
    name?: string;
    phone?: string;
    memo?: string;
    reason?: string;
    coachName?: string;
    categoryName?: string;
    desiredTime?: string;
    source?: string;
    raw: string;
}

/**
 * 키오스크에서 들어오는 소통 내용 파서.
 *   "[방문자 메모] 이름: X 전화번호: Y 메모: Z"  → visitor_memo
 *   "[관리자 호출] 사유: X"                   → manager_call
 *   "[강사 홍보 신청] ..."                    → trainer_promo_lead
 *   그 외                                    → other
 */
export const parseKioskContent = (content?: string | null): ParsedKioskContent => {
    const raw = (content ?? '').trim();
    if (!raw) return { type: 'other', raw };

    if (raw.startsWith('[방문자 메모]')) {
        const name = raw.match(/이름\s*:\s*([^\s전][^\n]*?)(?=\s*전화번호\s*:|\s*메모\s*:|$)/)?.[1]?.trim();
        const phone = raw.match(/전화번호\s*:\s*([0-9\-]+)/)?.[1]?.trim();
        const memo = raw.match(/메모\s*:\s*([\s\S]*)$/)?.[1]?.trim();
        return { type: 'visitor_memo', name, phone, memo, raw };
    }

    if (raw.startsWith('[관리자 호출]')) {
        const reason = raw.match(/사유\s*:\s*([\s\S]*)$/)?.[1]?.trim();
        return { type: 'manager_call', reason, raw };
    }

    if (raw.startsWith('[강사 홍보 신청]')) {
        const name = raw.match(/이름\s*:\s*([^\n]+)/)?.[1]?.trim();
        const phone = raw.match(/전화번호\s*:\s*([0-9\-]+)/)?.[1]?.trim();
        const coachName = raw.match(/강사\s*:\s*([^\n]+)/)?.[1]?.trim();
        const categoryName = raw.match(/카테고리\s*:\s*([^\n]+)/)?.[1]?.trim();
        const desiredTime = raw.match(/희망 시간\s*:\s*([^\n]+)/)?.[1]?.trim();
        const source = raw.match(/신청 경로\s*:\s*([^\n]+)/)?.[1]?.trim();
        const memo = raw.match(/메모\s*:\s*([\s\S]*)$/)?.[1]?.trim();
        return { type: 'trainer_promo_lead', name, phone, coachName, categoryName, desiredTime, source, memo, raw };
    }

    return { type: 'other', raw };
};

export const getKioskContentLabel = (type: KioskContentType): string => {
    switch (type) {
        case 'visitor_memo':
            return '방문자 메모';
        case 'manager_call':
            return '관리자 호출';
        case 'trainer_promo_lead':
            return '강사 홍보 신청';
        default:
            return '키오스크';
    }
};
